import Dashboard from "../pages/dashboard";
import Category from "../pages/category";
import Specification from "../pages/category/specification";
import AddCategory from "../pages/category/add";
import SubCategory from "../pages/subcategory";
import AddSubCategory from "../pages/subcategory/add";
import City from "../pages/city";
import AddCity from "../pages/city/add";
import State from "../pages/state";
import AddState from "../pages/state/add";
import Country from "../pages/country";
import AddCountry from "../pages/country/add";
import Size from "../pages/size";
import AddSize from "../pages/size/add";
import News from "../pages/news";
import AddNews from "../pages/news/add";
import Series from "../pages/series";
import AddSeries from "../pages/series/add";
import Slider from "../pages/slider";
import AddSlider from "../pages/slider/add";
import VehicleCategory from "../pages/vehiclecategory";
import Faqs from "../pages/faqs";
import AddFaqs from "../pages/faqs/add";
import HalpLine from "../pages/helpline";
import AddHalpLine from "../pages/helpline/add";
import AddVehicleCategory from "../pages/vehiclecategory/add";
import WorkerCategory from "../pages/workercategory";
import AddWorkerCategory from "../pages/workercategory/add";
import AppSettings from "../pages/settings/appsettings";
import LegalSettings from "../pages/settings/legalsettings";
import PolicySettings from "../pages/settings/policysettings";
import TermsSettings from "../pages/settings/termssettings";
import RefundSettings from "../pages/settings/refundsettings";
import ShippingSettings from "../pages/settings/shippingsettings";
import InquirySettings from "../pages/settings/inquirysetting";
import Testimonial from "../pages/testimonial/index";
import AddTestimonial from "../pages/testimonial/add";
import Users from "../pages/users";
import AddUsers from "../pages/users/add";
import Notification from "../pages/settings/notification";
import Subscription from "../pages/settings/subscription";
import AddSubscription from "../pages/settings/subscription/add";

const AdminRoutes = [

  { path: "master-dashboard", component: <Dashboard /> },

  { path: "users", component: <Users /> },
  { path: "users/add", component: <AddUsers /> },
  { path: "users/edit/:id", component: <AddUsers /> },

  { path: "category", component: <Category /> },
  { path: "category/add", component: <AddCategory /> },
  { path: "category/edit/:id", component: <AddCategory /> },

  { path: "specification", component: <Specification /> },

  { path: "subcategory", component: <SubCategory /> },
  { path: "subcategory/add", component: <AddSubCategory /> },
  { path: "subcategory/edit/:id", component: <AddSubCategory /> },

  { path: "vehicles-category", component: <VehicleCategory /> },
  { path: "vehicles-category/add", component: <AddVehicleCategory /> },
  { path: "vehicles-category/edit/:id", component: <AddVehicleCategory /> },

  { path: "worker-category", component: <WorkerCategory /> },
  { path: "worker-category/add", component: <AddWorkerCategory /> },
  { path: "worker-category/edit/:id", component: <AddWorkerCategory /> },

  { path: "city", component: <City /> },
  { path: "city/add", component: <AddCity /> },
  { path: "city/edit/:id", component: <AddCity /> },

  { path: "state", component: <State /> },
  { path: "state/add", component: <AddState /> },
  { path: "state/edit/:id", component: <AddState /> },

  { path: "country", component: <Country /> },
  { path: "country/add", component: <AddCountry /> },
  { path: "country/edit/:id", component: <AddCountry /> },

  { path: "size", component: <Size /> },
  { path: "size/add", component: <AddSize /> },
  { path: "size/edit/:id", component: <AddSize /> },

  { path: "slider", component: <Slider /> },
  { path: "slider/add", component: <AddSlider /> },
  { path: "slider/edit/:id", component: <AddSlider /> },

  { path: "send-notification", component: <Notification /> },

  { path: "series", component: <Series /> },
  { path: "series/add", component: <AddSeries /> },
  { path: "series/edit/:id", component: <AddSeries /> },

  { path: "settings/faqs", component: <Faqs /> },
  { path: "settings/faqs/add", component: <AddFaqs /> },
  { path: "settings/faqs/edit/:id", component: <AddFaqs /> },

  { path: "settings/help-line", component: <HalpLine /> },
  { path: "settings/help-line/add", component: <AddHalpLine /> },
  { path: "settings/help-line/edit/:id", component: <AddHalpLine /> },

  { path: "settings/testimonial", component: <Testimonial /> },
  { path: "settings/testimonial/add", component: <AddTestimonial /> },
  { path: "settings/testimonial/edit/:id", component: <AddTestimonial /> },

  { path: "settings/news", component: <News /> },
  { path: "settings/news/add", component: <AddNews /> },
  { path: "settings/news/edit/:id", component: <AddNews /> },

  { path: "settings/app-settings", component: <AppSettings /> },
  { path: "privacy/legal-settings", component: <LegalSettings /> },
  { path: "privacy/terms-settings", component: <TermsSettings /> },
  { path: "privacy/policy-settings", component: <PolicySettings /> },
  { path: "privacy/shipping-settings", component: <ShippingSettings /> },
  { path: "privacy/refund-settings", component: <RefundSettings /> },
  { path: "settings/inquiry-settings", component: <InquirySettings /> },

  { path: "settings/subscription", component: <Subscription /> },
  { path: "settings/subscription/add", component: <AddSubscription /> },
  { path: "settings/subscription/edit/:id", component: <AddSubscription /> },

];

export default AdminRoutes;
